var _title, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "person")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,22.2a9.56,9.56,0,1,1,9.55-9.55A9.56,9.56,0,0,1,20,22.2ZM20,5.84a6.81,6.81,0,1,0,6.8,6.81A6.81,6.81,0,0,0,20,5.84Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.62,36.45H4.38V35.07a15.62,15.62,0,1,1,31.24,0ZM7.2,33.7H32.8a12.87,12.87,0,0,0-25.6,0Z",
    fill: "#231f20"
  })));
}

export default SvgPerson;